import { render, staticRenderFns } from "./BookObservation.vue?vue&type=template&id=5769c4fe&"
import script from "./BookObservation.vue?vue&type=script&lang=js&"
export * from "./BookObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports